import { Typography } from '@mui/material'
import { CageItemDetails } from '../../TransfersTypes'
import * as S from './CageDetailsItemCard.styles'
import TableMui from 'src/components/TableMui'
import { useMemo } from 'react'

interface Props {
  sourceFc: string
  destinationFc: string
  item: CageItemDetails
}

export const CageDetailsItemCard = ({ sourceFc, destinationFc, item }: Props) => {
  const tableColums = [
    { id: 'quantity', label: 'Quantidade', testId: 'quantity-test-id' },
    { id: 'expirationDate', label: 'Data de validade', testId: 'expiration-date-test-id' },
    { id: 'operator', label: 'Operador', testId: 'operator-test-id' },
  ]

  const sourceBatches = useMemo(() => item.sourceBatches.map(({
    quantity,
    expirationDate,
    operator,
  }) => ({
    quantity,
    expirationDate,
    operator,
  })), [item.sourceBatches])

  const destinationBatches = useMemo(() => item.destinationBatches.map(({
    quantity,
    expirationDate,
    operator,
  }) => ({
    quantity,
    expirationDate,
    operator: operator || '-',
  })), [item.destinationBatches])

  return (
    <S.CardItem data-testid='cage-details-item-card-test-id'>
      <Typography variant='h6' fontWeight='bold' sx={{ alignSelf: 'center' }}>Detalhes do Item</Typography>
      <S.GridProductInfo>
        <S.CustomTextField
          name='productCode'
          id='productCode'
          label='Código do produto'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-product-code-test-id',
          }}
          value={item.productCode}
        />
        <S.CustomTextField
          name='productDescription'
          id='productDescription'
          label='Descrição do produto'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-product-description-test-id',
          }}
          value={item.productDescription}
        />
        <S.CustomTextField
          name='sourceQuantity'
          id='sourceQuantity'
          label='Qtd. na origem'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-source-quantity-test-id',
          }}
          value={item.sourceQuantity}
        />
        <S.CustomTextField
          name='destinationQuantity'
          id='destinationQuantity'
          label='Qtd. no destino'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-destination-quantity-test-id',
          }}
          value={item.destinationQuantity}
        />
      </S.GridProductInfo>
      <Typography
        variant='h6'
        sx={{
          marginTop: '.5rem',
          alignSelf: 'center',
          backgroundColor: '#76fd76',
          padding: '0rem 1rem 0rem 1rem',
          borderRadius: '5px 5px 0 0',
        }}
      >
        [ORIGEM] {sourceFc}
      </Typography>
      <TableMui
        thinLine
        columns={tableColums}
        emptyLabel='Nenhum lote para exibir'
        rows={sourceBatches}
        rowCount={sourceBatches.length}
        rowsPerPageLimit={25}
        enablePagination
        maxHeight='60vh'
        testId='table-source-batches-details-test-id'
      />
      <Typography
        variant='h6'
        sx={{
          marginTop: '1rem',
          alignSelf: 'center',
          backgroundColor: '#fdb376',
          padding: '0rem 1rem 0rem 1rem',
          borderRadius: '5px 5px 0 0',
        }}
      >
        [DESTINO] {destinationFc}
      </Typography>
      <TableMui
        thinLine
        columns={tableColums}
        emptyLabel='Nenhum lote para exibir'
        rows={destinationBatches}
        rowCount={destinationBatches.length}
        rowsPerPageLimit={25}
        enablePagination
        maxHeight='60vh'
        testId='table-destination-batches-details-test-id'
      />
    </S.CardItem>
  )
}
